// Renders one hand-authored stick-figure pose (see lib/animationPoses.js) as a simple
// reference sketch — shown next to a frame's upload slot so a GM drawing/generating frames
// one at a time can keep the whole sequence cohesive.
export function StickFigureGuide({ pose, label, className = "" }) {
  if (!pose) return null;
  const bones = [
    [pose.neck, pose.hip],
    [pose.neck, pose.leftShoulder], [pose.leftShoulder, pose.leftElbow], [pose.leftElbow, pose.leftHand],
    [pose.neck, pose.rightShoulder], [pose.rightShoulder, pose.rightElbow], [pose.rightElbow, pose.rightHand],
    [pose.hip, pose.leftHip], [pose.leftHip, pose.leftKnee], [pose.leftKnee, pose.leftFoot],
    [pose.hip, pose.rightHip], [pose.rightHip, pose.rightKnee], [pose.rightKnee, pose.rightFoot],
  ];
  return (
    <div className={`flex flex-col items-center gap-1 ${className}`}>
      <svg viewBox="0 0 100 150" className="w-16 h-24 md:w-20 md:h-28" data-testid="stick-figure-guide">
        <circle cx={pose.head[0]} cy={pose.head[1]} r="9" fill="none" stroke="#D4AF37" strokeWidth="2.5" />
        {bones.map(([a, b], i) => (
          <line key={i} x1={a[0]} y1={a[1]} x2={b[0]} y2={b[1]} stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round" />
        ))}
      </svg>
      {label && <p className="text-[9px] text-[#f1e0c5]/40 text-center leading-tight max-w-[80px]">{label}</p>}
    </div>
  );
}
